import { PencilSimpleLine } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

import { useCampaignFlowContext } from "../../../../context/CampaignFlowContext";
import { useFlowTemplateContext } from "./FlowTemplateContext";

export default function EditButton() {
  const { canEditFlow } = useCampaignFlowContext();
  const { handleStartEdit, flowTemplate } = useFlowTemplateContext();

  const isEditDisabled =
    !flowTemplate || !flowTemplate.original_id || !canEditFlow;

  return (
    <Button
      onClick={handleStartEdit}
      variant="secondary-purple"
      disabled={isEditDisabled}
      leftIcon={<PencilSimpleLine />}
    >
      Edit
    </Button>
  );
}
